import { useEffect, useState } from 'react'

import { ModelInterviewModel } from '../../../domain/models'

import {
  OpenQuestion,
  CheckboxQuestion,
  RadioAndSelectWithJustificationQuestion,
  SelectQuestion,
  ScaleQuestion
} from '../questions'

import * as S from './styles'

type PsychologicalQuestionInterviewProps = {
  modelInterview: ModelInterviewModel[]
  handleAnwers: (answers: ModelInterviewModel) => void
}

const PsychologicalQuestionInterview = ({
  modelInterview,
  handleAnwers
}: PsychologicalQuestionInterviewProps) => {
  const [answerToQuestion, setAnswerToQuestion] = useState<ModelInterviewModel>(
    {} as ModelInterviewModel
  )

  useEffect(() => {
    handleAnwers(answerToQuestion)
  }, [handleAnwers, answerToQuestion])

  useEffect(() => {
    if (modelInterview) {
      let newModelInterview = {} as ModelInterviewModel

      modelInterview?.forEach((item: any, index: any) => {
        if (item.resposta) {
          newModelInterview = { ...newModelInterview, [index]: item }
        }
      })

      setAnswerToQuestion(newModelInterview)
    }
  }, [modelInterview])

  return (
    <S.QuestionWrapper>
      {/* <S.QuestionTitle>Condições para realização da avaliação</S.QuestionTitle> */}
      <S.QuestionsContainer>
        {modelInterview?.map((item, index) => {
          if (item.pergunta.tipoPergunta.tipo === 'Aberta') {
            return (
              <OpenQuestion
                key={item.cdModeloEntrevista}
                label={item.pergunta.pergunta}
                value={item.resposta?.aberta}
                onChange={(e) => {
                  setAnswerToQuestion((prev) => ({
                    ...prev,
                    [index]: {
                      cdModeloEntrevista: item.cdModeloEntrevista,
                      pergunta: item.pergunta,
                      resposta: {
                        aberta: e?.target?.value
                      },
                      ordem: item.ordem,
                      dataCadastro: item.dataCadastro
                    }
                  }))
                }}
              />
            )
          }
          if (
            item.pergunta.tipoPergunta.tipo ===
            'Multipla Escolha com Justificativa'
          ) {
            return (
              <RadioAndSelectWithJustificationQuestion
                key={item.cdModeloEntrevista}
                options={item.pergunta.alternativas}
                label={item.pergunta.pergunta}
                order={item?.ordem}
                labelJustification={item.pergunta.perguntaSecundaria}
                labelThird={
                  item.pergunta.perguntaTerciaria &&
                  item.pergunta.perguntaTerciaria
                }
                optionChecked={item?.resposta?.respostaMarcada[0]}
                valueToJustification={item.resposta?.justificativa}
                onChange={(e, opt) => {
                  setAnswerToQuestion((prev) => ({
                    ...prev,
                    [index]: {
                      cdModeloEntrevista: item.cdModeloEntrevista,
                      pergunta: item.pergunta,
                      resposta: {
                        respostaMarcada: [opt],
                        ...(opt.alternativa !== 'Solteiro(a)' && {
                          justificativa: e?.target?.value
                        })
                      },
                      ordem: item.ordem,
                      dataCadastro: item.dataCadastro
                    }
                  }))
                }}
              />
            )
          }
          if (item.pergunta.tipoPergunta.tipo === 'Multipla Escolha') {
            return (
              <SelectQuestion
                key={item.cdModeloEntrevista}
                options={item.pergunta.alternativas}
                label={item.pergunta.pergunta}
                order={item?.ordem}
                optionSelected={item?.resposta?.respostaMarcada[0]}
                onChange={(opt) => {
                  setAnswerToQuestion((prev) => ({
                    ...prev,
                    [index]: {
                      cdModeloEntrevista: item.cdModeloEntrevista,
                      pergunta: item.pergunta,
                      resposta: {
                        respostaMarcada: [opt]
                      },
                      ordem: item.ordem,
                      dataCadastro: item.dataCadastro
                    }
                  }))
                }}
              />
            )
          }
          if (item.pergunta.tipoPergunta.tipo === 'Escala com Justificativa') {
            return (
              <ScaleQuestion
                key={item.cdModeloEntrevista}
                label={item.pergunta.pergunta}
                order={item?.ordem}
                labelJustification={item.pergunta.perguntaSecundaria}
                valueToJustification={item.resposta?.justificativa}
                optionChecked={item?.resposta?.escala}
                onChange={(e, valueRadio) => {
                  setAnswerToQuestion((prev) => ({
                    ...prev,
                    [index]: {
                      cdModeloEntrevista: item.cdModeloEntrevista,
                      pergunta: item.pergunta,
                      resposta: {
                        escala: valueRadio,
                        ...(!!valueRadio && {
                          justificativa: e?.target?.value
                        })
                      },
                      ordem: item.ordem,
                      dataCadastro: item.dataCadastro
                    }
                  }))
                }}
              />
            )
          }
          if (item.pergunta.tipoPergunta.tipo === 'Multiplas Escolhas') {
            return (
              <CheckboxQuestion
                key={item.cdModeloEntrevista}
                label={item.pergunta.pergunta}
                options={item.pergunta.alternativas}
                order={item?.ordem}
                optionChecked={item?.resposta?.respostaMarcada}
                onChange={(values) => {
                  setAnswerToQuestion((prev) => ({
                    ...prev,
                    [index]: {
                      cdModeloEntrevista: item.cdModeloEntrevista,
                      pergunta: item.pergunta,
                      resposta: {
                        respostaMarcada: Object.values(values)
                      },
                      ordem: item.ordem,
                      dataCadastro: item.dataCadastro
                    }
                  }))
                }}
              />
            )
          }
          return null
        })}
      </S.QuestionsContainer>
    </S.QuestionWrapper>
  )
}
export default PsychologicalQuestionInterview
